<table class="custom-table">
  <thead>
    <tr>
      @for (column of columns; track column.key) {
        <th [ngClass]="'align-' + column.align">
          <div [ngClass]="'table-head-' + column.align">
            {{ column.label }}
            @if (column.allowSort) {
              @if (sortColumn === column.key) {
                <img
                  class="active"
                  (click)="setSort(column.key)"
                  (keyup.enter)="setSort(column.key)"
                  (keyup.space)="setSort(column.key)"
                  tabindex="0"
                  [src]="
                    'assets/filter-' +
                    (sortDirection === SortDirection.ASC ? 'asc' : 'desc') +
                    '.svg'
                  "
                  alt="Filter Icon"
                />
              } @else {
                <img
                  (click)="setSort(column.key)"
                  (keyup.enter)="setSort(column.key)"
                  (keyup.space)="setSort(column.key)"
                  tabindex="0"
                  src="../../../../../assets/filter.svg"
                  alt="Filter Icon"
                />
              }
            }
          </div>
        </th>
      }
      <th class="align-center">
        <div class="table-head-center">Aktion</div>
      </th>
    </tr>
  </thead>
  <tbody>
    @for (g of groups; track g.id) {
      <tr class="hover-pointer" (click)="onRowClick(g)">
        <td class="responsive-cell">
          <span class="bold-styling">{{ g.name }}</span>
        </td>
        <td class="responsive-cell">
          <span>{{ g.customerName || g.customerId || '-' }}</span>
        </td>
        <td class="responsive-cell">
          <span>{{ getOrderTitlesDisplay(g).join(', ') || '-' }}</span>
        </td>
        <td class="responsive-cell align-center">
          {{ getMemberCount(g) }}
        </td>
        <td class="responsive-cell align-center">
          <button class="link-like" (click)="$event.stopPropagation(); onRowClick(g)">Bearbeiten</button>
        </td>
      </tr>
    }
    @if (!groups || groups.length === 0) {
      <tr>
        <td colspan="5" class="align-center">Keine Daten vorhanden.</td>
      </tr>
    }
  </tbody>
  <tfoot>
    <tr>
      <td colspan="5">
        <div class="pagination-controls">
          <p-paginator
            (onPageChange)="onPageChange($event)"
            [first]="first"
            [rowsPerPageOptions]="itemsPerPageOptions"
            [rows]="itemsPerPageShown"
            [totalRecords]="totalRecords"
          />
        </div>
      </td>
    </tr>
  </tfoot>
</table>
